import UserManagerContainer from "../../container/admin/user-manager";

const UserManager = () => {
    return <UserManagerContainer />;
};

export default UserManager;